module.exports = __webpack_public_path__ + "static/media/icMedical_manager.a36f0339.svg";